import React, { Component }  from 'react';
import {format} from 'react-string-format';
import Game from "./Game";
import * as ReactDOM from 'react-dom';
import {NavLink} from "react-router-dom";
import {withRouter} from "./withRouter";
import {Col, Container, Row} from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";

class Genres extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: []
        };
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + "/customer/game/genres")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    render() {
        const { error, isLoaded, items } = this.state;

        var content = null;

        if (error) {
            content = <div>{error ? <div className="alert alert-danger">
                <p>Session token has expired. Please, <a href="/account">login</a> again</p>
            </div> :<empty/>}</div>;
        } else if (!isLoaded) {
            content = <div>Loading...</div>;
        } else {
            content = (<div style={{
                paddingRight: 150,
                    paddingLeft: 150,
                    paddingTop: 50,
                    paddingBottom: 50,
                    borderRadius: 8
                }}>
                <Carousel class="col-sm-2" variant="dark" slide={true}>
                    {items.map(item => (
                        <Carousel.Item>
                            <img style={{
                                opacity: 0.6,
                                maxWidth: "100%",
                                maxHeight: "80%",
                                borderRadius: 9,
                                borderColor: "darkgray",
                            }}
                                 src={item.image}
                                 alt=""
                                 width="100%"
                                 align="center"
                            >
                            </img>
                            <Carousel.Caption style={{
                                zIndex:2,
                                background: `linear-gradient(rgba(255,255,255,0), rgba(255,255,255,1))`,
                                bottom:0,
                                left: 0,
                                right: 0,
                            }}>
                                <h1>{item.genre.toUpperCase()}</h1>
                                <h3>{item.total} {item.total > 1 ? "apps total" : "app"}</h3>
                                <br/>
                                <NavLink
                                    to={"/genres/" + item.genre}
                                    className="btn btn-dark"
                                >
                                    OPEN
                                </NavLink>
                            </Carousel.Caption>
                        </Carousel.Item>
                    ))}
                </Carousel>
                </div>
            );
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>;
    }
}

export default withRouter(Genres);
